import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import Home from './Home';


const theme = extendTheme({
  fonts: {
    heading: `'Cairo', sans-serif`,
    body: `'Cairo', sans-serif`,
  },
  colors: {
    brand: {
      navy: '#0a192f',
      red: '#E53E3E',
      white: '#ffffff',
    },
  },
  styles: {
    global: {
      body: {
        bg: 'brand.navy',
        color: 'brand.white',
      },
    },
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Home />
    </ChakraProvider>
  );
}

export default App;
